const canceledTokens = ["abort", "cancel"] as const;

const readErrorText = (value: unknown): string =>
  typeof value === "string" ? value.toLowerCase() : "";

export const isCanceledQueryError = (err: unknown): boolean => {
  if (typeof err !== "object" || err === null) {
    return false;
  }
  const payload = err as {
    name?: unknown;
    message?: unknown;
    error?: { name?: unknown; message?: unknown };
  };
  const tokens = [
    readErrorText(payload.name),
    readErrorText(payload.message),
    readErrorText(payload.error?.name),
    readErrorText(payload.error?.message),
  ];
  return tokens.some((token) =>
    canceledTokens.some((canceledToken) => token.includes(canceledToken)),
  );
};
